import i18n from 'i18n';
import { FormTemplateValidator } from 'data/template/template.types';
import Form from '../index';

export default class LessThanValidator {
  private static TYPE = 'lessThanValidator';

  public static isType(type: string): boolean {
    return LessThanValidator.TYPE === type;
  }

  public static isValid(
    _propFields: unknown,
    _stateFields: unknown,
    value: string,
    _lastSavedValue: unknown,
    validator: FormTemplateValidator,
    form: Form,
  ): boolean {
    const comparingValue = Number(form.getValue(validator.compareToKey));
    const fieldValue = Number(value);

    if (Number.isNaN(fieldValue)) {
      return false;
    }

    if (Number.isNaN(comparingValue)) {
      return true;
    }

    return fieldValue < comparingValue;
  }

  public static getErrorMessage({ errorMessage }: FormTemplateValidator): string | null {
    return errorMessage || '';
  }
}
